angular.module('trainerWebApp.services').factory('manageGroupsSearch', ['searchHelper', 'userGridUtils', 'trackingService', function (searchHelper, userGridUtils, trackingService) {
  function createSearchSettings(params) {

    function getSuggestedUserNames(users){
      return function(){
        return _.map(users, function(u){
          return {
            name: u.lastName + ", " + u.firstName,
            id: u.id
          };
        });
      }
    }

    function getSuggestedUserEmails(users) {
      return function () {
        return _.map(_.filter(users, function(u){ return u.email; }), function (u) {
          return {
            name: u.email,
            id: u.id
          }
        });
      }
    }

    function getSuggestedUserUsernames(users){
      return function(){
        return _.map(_.filter(users, function(u){ return u.username; }), function(u) {
          return {
            name: u.username,
            id: u.id
          }
        });
      }
    }


    function fieldTracking(name){
      return function(){

      }
    };

    function filterByGroupIds(group, groupIds){
      return _.contains(groupIds, group.id);
    }

    function filterByTrainerGroupIds(group, groupIds){
      if (!groupIds){ return true; }
      return _.contains(groupIds, group.id);
    }

    var fields = [
      {
        name: 'group',
        label: 'Group',
        shortcut: 'group',
        createFilterSync: searchHelper.createCompositeSearchFieldFilter2(
          searchHelper.filterFieldIndexOf('name')
        ),
        track: fieldTracking('none')
      },
      {
        name: 'userName',
        label: 'Name',
        shortcut: 'userName',
        createFilterAsync: function(id, cb){
          params.getUserGroups(id, function(groupIds){
            var filter = userGridUtils.filter.createFilter(filterByGroupIds, [groupIds]);
            cb(filter);
          });
        },
        groupLabel: 'Names:',
        groupName: 'userNameGroup',
        getSuggestions: getSuggestedUserNames(params.users),
        track: fieldTracking('none')
      },
      {
        name: 'userEmail',
        label: 'Email',
        shortcut: 'userEmail',
        createFilterAsync: function(id, cb){
          params.getUserGroups(id, function(groupIds){
            var filter = userGridUtils.filter.createFilter(filterByGroupIds, [groupIds]);
            cb(filter);
          });
        },
        groupLabel: 'Emails:',
        groupName: 'userEmailGroup',
        getSuggestions: getSuggestedUserEmails(params.users),
        track: fieldTracking('none')
      }
    ];

    if (params.isUsernameEnabled){
      fields.push({
        name: 'userUsername',
        label: 'Username',
        shortcut: 'userUsername',
        createFilterAsync: function(id, cb){
          params.getUserGroups(id, function(groupIds){
            var filter = userGridUtils.filter.createFilter(filterByGroupIds, [groupIds]);
            cb(filter);
          });
        },
        groupLabel: 'Usernames:',
        groupName: 'userUsernameGroup',
        getSuggestions: getSuggestedUserUsernames(params.users),
        track: fieldTracking('none')
      });
    }

    if (params.showTrainerPermissions){
      fields.push({
        name: 'trainerName',
        label: 'Trainer Name',
        shortcut: 'trainerName',
        createFilterAsync: function(id, cb){
          params.getTrainerGroups(id, function(groupIds){
            var filter = userGridUtils.filter.createFilter(filterByTrainerGroupIds, [groupIds]);
            cb(filter);
          });
        },
        groupLabel: 'Trainer Names:',
        groupName: 'trainerNameGroup',
        getSuggestions: getSuggestedUserNames(params.trainers),
        track: fieldTracking('none')
      });
      fields.push({
        name: 'trainerEmail',
        label: 'Trainer Email',
        shortcut: 'trainerEmail',
        createFilterAsync: function(id, cb){
          params.getTrainerGroups(id, function(groupIds){
            var filter = userGridUtils.filter.createFilter(filterByTrainerGroupIds, [groupIds]);
            cb(filter);
          });
        },
        groupLabel: 'Trainer Emails:',
        groupName: 'trainerEmailGroup',
        getSuggestions: getSuggestedUserEmails(params.trainers),
        track: fieldTracking('none')
      });
      fields.push({
        name: 'managerName',
        label: 'Manager Name',
        shortcut: 'managerName',
        createFilterAsync: function(id, cb){
          params.getTrainerGroups(id, function(groupIds){
            var filter = userGridUtils.filter.createFilter(filterByTrainerGroupIds, [groupIds]);
            cb(filter);
          });
        },
        groupLabel: 'Manager Names:',
        groupName: 'managerNameGroup',
        getSuggestions: getSuggestedUserNames(params.managers),
        track: fieldTracking('none')
      });
      fields.push({
        name: 'managerEmail',
        label: 'Manager Email',
        shortcut: 'managerEmail',
        createFilterAsync: function(id, cb){
          params.getTrainerGroups(id, function(groupIds){
            var filter = userGridUtils.filter.createFilter(filterByTrainerGroupIds, [groupIds]);
            cb(filter);
          });
        },
        groupLabel: 'Manager Emails:',
        groupName: 'managerEmailGroup',
        getSuggestions: getSuggestedUserEmails(params.managers),
        track: fieldTracking('none')
      });

      if (params.isUsernameEnabled){
        fields.push({
          name: 'trainerUsername',
          label: 'Trainer Username',
          shortcut: 'trainerUsername',
          createFilterAsync: function(id, cb){
            params.getTrainerGroups(id, function(groupIds){
              var filter = userGridUtils.filter.createFilter(filterByTrainerGroupIds, [groupIds]);
              cb(filter);
            });
          },
          groupLabel: 'Trainer Usernames:',
          groupName: 'trainerUsernameGroup',
          getSuggestions: getSuggestedUserUsernames(params.trainers),
          track: fieldTracking('none')
        });
        fields.push({
          name: 'managerUsername',
          label: 'Manager Username',
          shortcut: 'managerUsername',
          createFilterAsync: function(id, cb){
            params.getTrainerGroups(id, function(groupIds){
              var filter = userGridUtils.filter.createFilter(filterByTrainerGroupIds, [groupIds]);
              cb(filter);
            });
          },
          groupLabel: 'Manager Usernames:',
          groupName: 'managerUsernameGroup',
          getSuggestions: getSuggestedUserUsernames(params.managers),
          track: fieldTracking('none')
        });
      }
    }

    return {
      fields: fields,
      setFilter: params.setFilter,
      filterHasResults: params.filterHasResults,
      gaPageName: params.gaPageName,
      notifySearchChanged:params.notifySearchChanged
    }
  }

  return {
    createSearchSettings: createSearchSettings
  }
}]);
